<div
  class="border-radius-100 d-flex align-items-center justify-content-center c-t-gray-100 avatar {{ selectable ? 'cursor-pointer' : 'pointer-events-none' }} position-relative"
  [class.avatar--selected]="selected"
  [class.fw-semibold]="selected"
  [style.background-color]="text | avatarColor"
  [style.border-color]="text | avatarColor"
  [width]="size + 'px'"
  [height]="size + 'px'"
  [style.font-size.px]="size * .4"
  (click)="selected = true; selectedChange.emit(selected)"
>
  {{ text }}

  @if (showDeleteButton) {
    <button
      class="icon-button sm c-t-gray-700 position-absolute delete-button"
      type="button"
      (click)="$event.stopPropagation(); delete.emit(email)"
    >
      <i class="ri-close-circle-fill"></i>
    </button>
  }
</div>
